import axios from 'axios'
import {
  getToken,
  getRefreshToken,
  getLang,
  getProject
} from '@/utils/auth'
import store from '@/store'
import {
  Notification
} from 'element-ui';
// axios.defaults.baseURL = '/api'
// axios.defaults.timeout = 1000 * 60 * 10;
// // 设置请求传递数据的格式（看服务器要求什么格式）
// // 设置超时时间和跨域是否允许携带凭证
// axios.defaults.withCredentials = false
// console.log('defaults.withCredentials', axios.defaults);
// // request拦截器
// // request拦截器

// create an axios instance
const service = axios.create({
  baseURL: '/api', // url = base url + request url
  withCredentials: false, // send cookies when cross-domain requests
  timeout: 50000 // request timeout
})
// console.log('withCredentials', service);
service.interceptors.request.use(
  config => {
    config.headers['Accept-Language'] = getLang() // 让每个请求携带自定义token 请根据实际情况自行修改
    config.headers['Content-Type'] = 'application/json'
    // console.log('getProject() ', getProject());
    if (getProject() && getProject() != null && getProject() != "null") {
      config.headers['project'] = getProject()
    }
    // console.log(config.headers);
    // config.headers['Cookie'] = ''
    // console.log(getToken());
    if (getToken()) {
      config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
      // console.log('config.headers.Cookie', config.headers);
    } else {
      console.log("Token未获取或未存储");
    }
    if (config.method === 'get') {
      config.data = {
        unused: 0
      }
    }
    // console.log('config.headers', config);
    return config
  },
  error => {
    Promise.reject(error)
  }
)
let isRefreshing = false
let i = 0
service.interceptors.response.use(
  response => {
    // console.log('response', response)
    if (response.headers["content-disposition"]) {
      response.data.contentDisposition = response.headers["content-disposition"]
    }
    if (response.data.code == '403' ||
      response.data.code == '401') {
      Notification({
        title: '警告',
        message: '没有权限',
        type: 'warning',
        showClose: true
      });
    }
    // console.log("响应utile", response);
    if (response.data.msg == '登出失败') {
      return
    } else if (response.data.code == 500 && response.data.msg.includes('refresh token')) {
      Notification({
        title: '警告',
        message: 'refresh token已过期，正在返回登陆页面......',
        type: 'warning',
        showClose: true
      });
      console.log("refresh token 过期");
      store.dispatch('LogOut').then(() => {
        location.reload()
      })
      return
    }
    if (response.data.code == 500 && response.data.msg.includes('token')) {
      if (!isRefreshing && i == 0) {
        if (i == 0) {
          Notification({
            title: '警告',
            message: 'Token已过期，正在重新请求......',
            type: 'warning',
            showClose: false
          });
          ++i
          isRefreshing = true
          const Loginform = {}
          Loginform.clientId = "web"
          Loginform.clientSecret = 654321
          Loginform.refreshToken = getRefreshToken()
          Loginform.grantType = "refresh_token"
          // console.log("token 过期");
          store.dispatch('refreshtoken', Loginform).then((res) => {
            // console.log('refreshtoken', res);
            // console.log('response.config', response.config);
            isRefreshing = false
            location.reload()
          })
        }
      }
      return service(response.config)
    }
    return response.data
  },
  error => {
    // console.log(error);
    // 兼容blob下载出错json提示
    console.log('error.response', error);
    if (error.response.data instanceof Blob && error.response.data.type.toLowerCase().indexOf('json') !== -1) {
      const reader = new FileReader()
      reader.readAsText(error.response.data, 'utf-8')
      reader.onload = function (e) {
        const errorMsg = JSON.parse(reader.result).message
        Notification.error({
          title: errorMsg,
          duration: 5000
        })
      }
    } else {
      let code = 0
      try {
        code = error.response.data.status
      } catch (e) {
        if (error.toString().indexOf('Error: timeout') !== -1) {
          Notification.error({
            title: '网络请求超时',
            duration: 5000
          })
          return Promise.reject(error)
        }
      }
    }
    return Promise.reject(error)
  }
)


export default service